// extracted by mini-css-extract-plugin
export var breadcrumb = "_1g-0";
export var breadcrumbArrow = "_1g-1";